import { render } from "./SupportDocPhotoGuidance.vue?vue&type=template&id=b2459faa&scoped=true"
const script = {}

import "./SupportDocPhotoGuidance.vue?vue&type=style&index=0&id=b2459faa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2459faa"]])

export default __exports__